import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from '../axiosBaseQuery';

const T_AND_C_REG = 'REG_TC_SCHOOLS';
const T_AND_C_GDPR = 'GDPR_SCHOOLS';
const T_AND_C_GLOBAL = 'GLOBALPRIV_SCHOOLS';
const T_AND_C_LOCAL = 'LOCALPRIV_SCHOOLS';
const T_AND_C_PAYMENT = 'PAYMENT_SCHOOLS';

export interface TermsResponse {
  Text: string;
}

export interface Terms {
  text: string;
}

export const termsApi = createApi({
  reducerPath: 'termsApi',
  baseQuery: axiosBaseQuery({
    baseUrl: '/web-api',
  }),
  endpoints: (builder) => ({
    getSignInTnC: builder.query<Terms, void>({
      query: () => ({
        url: `/api/content/getTermsAndConditionsTextByType/B2C/${T_AND_C_REG}`,
        method: 'get',
      }),
      transformResponse: (res: TermsResponse) => ({
        text: res.Text,
      }),
    }),
    getShortSignInTnC: builder.query<Terms, void>({
      query: () => ({
        url: `/api/content/getTermsAndConditionsTextByType/B2C/${T_AND_C_GDPR}`,
        method: 'get',
      }),
      transformResponse: (res: TermsResponse) => ({
        text: res.Text,
      }),
    }),
    getGlobalTnc: builder.query<Terms, number | string>({
      query: (countryId) => ({
        url: `/api/content/getTermsAndConditionsTextByType/B2C/${T_AND_C_GLOBAL}/${countryId}`,
        method: 'get',
      }),
      transformResponse: (res: TermsResponse) => ({
        text: res.Text,
      }),
    }),
    getLocalTnc: builder.query<Terms, number | string>({
      query: (countryId) => ({
        url: `/api/content/getTermsAndConditionsTextByType/B2C/${T_AND_C_LOCAL}/${countryId}/true`,
        method: 'get',
      }),
      transformResponse: (res: TermsResponse) => ({
        text: res.Text,
      }),
    }),
    getPaymentTnc: builder.query<Terms, number | string>({
      query: (countryId) => ({
        url: `/api/content/getTermsAndConditionsTextByType/B2C/${T_AND_C_PAYMENT}/${countryId}/true`,
        method: 'get',
      }),
      transformResponse: (res: TermsResponse) => ({
        text: res.Text,
      }),
    }),
    createRegistration: builder.mutation<string, any>({
      query: (data) => ({
        url: `/api/examregistation/createregistration`,
        method: 'post',
        data: data,
      }),
      // in that case there will be always one rg
      transformResponse: (res: { Reference: string[] }) => res.Reference[0],
    }),
  }),
});

export const {
  useGetSignInTnCQuery,
  useGetShortSignInTnCQuery,
  useGetGlobalTncQuery,
  useGetLocalTncQuery,
  useLazyGetPaymentTncQuery,
  useGetPaymentTncQuery,
  useCreateRegistrationMutation,
} = termsApi;
